import {FC} from "react";
import {UserAttendanceTabContent} from "./content";
import {useOutletContext} from "react-router-dom";
import {UserPageOutletContext} from "../index";

export const UserAttendanceTab: FC<any> = () => {
    const [user] = useOutletContext<UserPageOutletContext>();
    return <UserAttendanceTabContent user={user}/>;
};
